export default __webpack_public_path__ + "static/media/avatar.68a40843.svg";